import DemoPanel from "@/components/preview/demo-panel";
import ResultLabel from "@/components/preview/result-label";
import { ResultBadge } from "@/components/ui/result-badge";
import { cn } from "@/lib/utils";

interface ResultPanelProps {
  bad?: boolean;
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
  label?: React.ReactNode;
}

export default function ResultPanel({
  bad = false,
  children,
  className,
  innerClassName,
  label,
}: ResultPanelProps) {
  if (label !== undefined) {
    return (
      <DemoPanel
        className={className}
        footer={
          <ResultLabel
            bad={bad}
            className="whitespace-nowrap font-berkeley-mono"
            size="sm"
          >
            {label}
          </ResultLabel>
        }
        footerPosition="top"
        innerClassName={innerClassName}
      >
        {children}
      </DemoPanel>
    );
  }

  return (
    <DemoPanel
      className={className}
      innerClassName={cn("flex-col gap-4", innerClassName)}
    >
      {children}
      <ResultBadge bad={bad} />
    </DemoPanel>
  );
}
